<template>
    <div class="home">
      <BannerHome></BannerHome>
      <HomeEmpreendiments></HomeEmpreendiments>
      <HomeBlog></HomeBlog>
    </div>
</template>

<script>
import BannerHome from './BannerHome.vue'
import HomeEmpreendiments from './HomeEmpreendiments.vue'
import HomeBlog from './HomeBlog.vue'

export default {
  components: {
    BannerHome,
    HomeEmpreendiments,
    HomeBlog
  },
  created () {
    document.title = 'Comcasa | Home'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue